<template>
  <div>
    <div class="section-about">
      <div class="jumbotron jumbotron-fluid header">
        <div class="container">
          <h1 class="display-4 title">HOW WE CALCULATE THE RANKINGS</h1>
          <!-- <div class="line"></div> -->
          <p class="lead">ByteArk CDN มีการจับเวลา และปริมาณที่ใช้ในการส่งข้อมูลออกจากระบบ CDN ของ ByteArk
        ซึ่งสามารถคำนวณกลับมาเป็นความเร็วของอินเทอร์เน็ตของผู้ใช้งานได้
        โดยเราจะกรองผลการคำนวณจากการเรียกใช้งานข้อมูลที่มีขนาดตั้งแต่ 1 MB ขึ้นไป</p>
        <p>* เวลา Prime Time หมายถึงช่วงเวลา 20:00 - 22:00 ของแต่ละวัน ซึ่งเป็นช่วงเวลาที่มีการใช้อินเตอร์เน็ตอย่างหนาแน่น และสะท้อนถึงประสบการณ์ใช้งานของผู้ใช้ส่วนใหญ่ที่จะได้รับจากการใช้งานจริง
        </p>
        </div>
      </div>
      <div class="bg-overlay"></div>
    </div>
<!--     <div class="jumbotron jumbotron-fluid section-header">
      <div class="container">
        <h1 class="display-4">HOW WE CALCULATE THE RANKINGS</h1>
      </div>
    </div>
    <div class="section section-about">
      <div class="container">
        <div class="detail">ByteArk CDN มีการจับเวลา และปริมาณที่ใช้ในการส่งข้อมูลออกจากระบบ CDN ของ ByteArk
        ซึ่งสามารถคำนวณกลับมาเป็นความเร็วของอินเทอร์เน็ตของผู้ใช้งานได้
        โดยเราจะกรองผลการคำนวณจากการเรียกใช้งานข้อมูลที่มีขนาดตั้งแต่ 1 MB ขึ้นไป</div>
      </div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'about',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';

.section-about {
  min-height: calc(100vh - 116px);
  height: calc(100vh - 116px);
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%2303a9f4' fill-opacity='0.2' fill-rule='evenodd'/%3E%3C/svg%3E"),linear-gradient(to bottom, #03a9f4, #0092d5);
  background-color:rgba(0,166,237, 1);
  color: white;
  position: relative;
  .header {
    background-color: transparent;
    padding-top: calc(25vh - 50px);
    .title {
      font-weight: 700;
    }
    .line {
      width: 90%;
      height: 2px;
      border: solid 2px $gray-200;
      margin-top: 10px;
      margin-bottom: $spacer * 2;
    }
  }

  .bg-overlay {
    background-image: url('/static/images/bg-header-byteark.png');
    background-repeat: no-repeat;
    background-position-y: top;
    background-position-x: center;
    bottom: 0;
    height: calc(25vh);
    left: 0;
    right: 0;
    width: 100%;
    position: absolute;
    background-size: 65%;
  }
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  .section-about {
    padding-bottom: 80px;
    height: auto;
    .bg-overlay {
      height: 120px;
      background-size: cover;
    }
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .section-about {
    .bg-overlay {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutCalculate.vue